document.addEventListener("DOMContentLoaded", () => {
  function setPromoMinHeight() {
    // Check if screen width is at least 700px
    if (window.innerWidth >= 700) {
      // Select the product-card element
      const productCard = document.querySelector('product-card');
      
      // Select all elements with the class 'product-list__promo'
      const promoElements = document.querySelectorAll('.product-list__promo');

      if (productCard && promoElements.length > 0) {
        // Get the rendered height of the product-card element
        const productCardHeight = productCard.offsetHeight;

        // Apply the height as min-height to all promo elements
        promoElements.forEach((element) => {
          element.style.minHeight = `${productCardHeight}px`;
        });
      }
    } else {
      // Remove min-height if the screen is smaller than 700px
      document.querySelectorAll('.product-list__promo').forEach((element) => {
        element.style.minHeight = "";
      });
    }
  }

  // Run the function on page load
  setPromoMinHeight();

  // Run the function on window resize
  window.addEventListener("resize", setPromoMinHeight);
});
